module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/design_pin_logo-37e4f8082c2091b0b31a3157732fa606.svg&quot;;"